import {SpanIcon} from '@mazraeapp/react_icon_kit';

interface IDetailShopProps {
  has_delivery?: boolean;
  has_guarantee?: boolean;
  in_person_possibility?: boolean;
}

const DetailShopText = ({
  has_delivery,
  has_guarantee,
  in_person_possibility,
}: IDetailShopProps) => {
  return (
    <div className="flex justify-between w-full px-4 mt-4 text-sm text-gray-500">
      <div className="flex flex-col items-center justify-center flex-1 gap-2">
        <i className="text-xl icon-nameStore1 " />
        <span className="text-xs">امکان مراجعه حضوری</span>
        <SpanIcon
          className={`${
            in_person_possibility
              ? 'icon-nameCheckmark'
              : 'icon-nameClose-remove'
          } text-farm-shop-500 text-xl`}
        />
      </div>
      <div className="w-[1px] h-4 bg-gray-300" />
      <div className="flex flex-col items-center justify-center flex-1 gap-2">
        <i className="text-xl icon-truck" />
        <span className="text-xs"> امکان ارسال</span>
        <SpanIcon
          className={`${
            has_delivery ? 'icon-nameCheckmark' : 'icon-nameClose-remove'
          } text-farm-shop-500 text-xl`}
        />
      </div>
      <div className="w-[1px] h-4 bg-gray-300" />
      <div className="flex flex-col items-center justify-center flex-1 gap-2">
        <i className="text-xl icon-check-shield" />
        <span className="text-xs">ضمانت کیفیت</span>
        <i
          className={`${
            has_guarantee ? 'icon-nameCheckmark' : 'icon-nameClose-remove'
          } text-farm-shop-500 text-xl`}
        />
      </div>
    </div>
  );
};

export default DetailShopText;
